
<template>
  <div id="transactions" v-if="showWindow">
    <vs-popup classContent="popup-example" title="Table setup" :active.sync="popupActive">
      <div class="vx-row mb-4">
        <div class="vx-col w-1/4" v-for="(column,index) in columnDefs" :key="index" style="padding: 5px">
          <vs-button class="ml-auto w-full" color="primary" :type="getType(column.field)" @click="showHideColumn(column.field)">{{column.headerName}}</vs-button> 
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Generate invoice" :active.sync="popupInvoiceActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" v-model="clientInvoice" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="goTo('invoices')" color="primary" type="filled">Generate</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Refund" :active.sync="popupRefund">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Account
          <v-select v-model="params.destination" label="acc_name" :options="account" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Comments
          <vs-input class="inputx w-full" v-model="params.comments" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('refund')" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update broker" :active.sync="popupUpdateBroker">
    <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Broker
          <v-select v-model="params.bk_name1" label="bk_name" :options="brokers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('update-broker')" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Insert bank deposit" :active.sync="popupBankDeposit">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Exp date
          <datepicker placeholder="Select Date" v-model="params.created_at1"></datepicker>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Broker
          <v-select v-model="params.bk_name1" label="bk_name" :options="brokers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Account
          <v-select v-model="params.account_name1" label="acc_name" :options="account" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Amount 
          <vs-input class="inputx w-full" v-model="amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Cur name          
          <v-select v-model="params.curname1" label="currency" :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Comments
          <vs-input class="inputx w-full" v-model="params.comments1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Sender name
          <vs-input class="inputx w-full" v-model="params.sender_name1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          From acc
          <vs-input class="inputx w-full" v-model="params.from_acc1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Description
          <vs-input class="inputx w-full" v-model="params.descript1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Ext ref
          <vs-input class="inputx w-full" v-model="params.ext_ref1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('bank-deposit')" color="primary" type="filled">Insert</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update manual ref" :active.sync="popupManual">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-textarea class="inputx w-full" label="Reference string" v-model="params.reference_string" ></vs-textarea>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Reference" v-model="params.reference" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('update-manual')" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update client" :active.sync="popupUpdateClient">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Type" v-model="params.new_id" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('new-id')" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Send group" :active.sync="popupGroup">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Type
          <v-select v-model="params.tran_type" label="t_desc" :options="trantype" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Destination
          <v-select v-model="params.destination" label="acc_name" :options="account" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="params.amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('send-group')" color="primary" type="filled">Send</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update client" :active.sync="popupTLID">
      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-button @click="sendData('bank-oft')" color="danger" type="filled">Bank oft</vs-button>
        </div>
        <div class="vx-col w-1/3">
          <vs-button @click="sendData('delete-deposit')" color="primary" type="border">Delete deposit</vs-button>
        </div>
        <div class="vx-col w-1/3">
          <vs-button @click="sendData('unmatch-client')" color="primary" type="filled">Unmatch client</vs-button>
        </div>
        <div class="vx-col w-1/3">
          <vs-button @click="popupTLID=false;popupUpdateBroker=true" color="warning" type="filled">Update broker</vs-button>
        </div>
        <div class="vx-col w-1/3">
          <vs-button @click="popupTLID=false;popupGroup=true" color="dark" type="border" >Send group</vs-button>
        </div>
        <div class="vx-col w-1/3">
          <vs-button @click="popupTLID=false;popupRefund=true" color="dark" type="border" >Refund</vs-button>
        </div>
      </div>
    </vs-popup>
    <div class="vx-col w-full mb-base">
			<vx-card title="Filter">
				<div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-2">
            
            <div class="mt-5">
              created at
              <div>
                <flat-pickr :config="configFromdateTimePicker" v-model="dateRange" placeholder="Select range" @on-change="onRangeChange" ref="programaticOpen"/>
                <vs-button class="mb-4"  color="dark" type="border" @click="resetDate" data-clear>All time</vs-button>
              </div>
            </div>
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-2">
            <div class="mt-5">
                <div>
                  Broker
                  <v-select multiple :closeOnSelect="false" v-model="searchParams.broker" label="bk_name" :options="brokers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
                <div class="mt-4">
                  Status
                  <v-select multiple :closeOnSelect="false" v-model="searchParams.status" label="st_name" :options="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
            </div>
					</div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <div class="mt-5">
                <div>
              Country
              <v-select multiple :closeOnSelect="false" v-model="searchParams.country" label="cl_Country" :options="country" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
                <div class="mt-4">
              Account
              <v-select multiple :closeOnSelect="false" v-model="searchParams.account" label="acc_name" :options="account" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
            </div>
					</div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <div class="mt-5">
                <div>
                    Group
                    <v-select multiple :closeOnSelect="false" v-model="searchParams.tran_group" label="t_name" :options="tran_group" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    
                    <div class="mt-4">
                <br />
                <vs-button class="mr-3 mb-2" @click="setData">Submit</vs-button>
              </div>
                </div>
            </div>
					</div>
					<div class="vx-col w-full">
            <br />
            <vs-button color="warning" type="border" class="mr-3 mb-2" @click="popupBankDeposit=true">Insert bank deposit</vs-button>
            <vs-button color="primary" type="border" class="mr-3 mb-2" @click="popupManual=true">Update manual ref</vs-button>   
            <vs-button color="danger" type="border" class="mr-3 mb-2" @click="goTo('details')">Generate details</vs-button>     
            <vs-button color="primary" type="border" class="mr-3 mb-2" @click="getClientsList">Generate invoice</vs-button>       
					</div>
				</div>	
    </vx-card>
  </div>
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ tableData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : tableData.length }} of {{ tableData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <vs-button type="line" color="primary" icon-pack="feather" icon="icon-settings" @click="popupActive=true"></vs-button>
          <vs-button color="danger" type="border" class="mr-3 mb-2" @click="showDod()">Show dod</vs-button>
          <vs-button color="primary" type="border" class="mr-3 mb-2" @click="popupTLID=true">tl_id actions</vs-button>
        </div>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        @grid-ready="onGridReady"
        @cellClicked="onCellClicked"
        :rowData="tableData"
        rowSelection="multiple"
        rowMultiSelectWithClick="true"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage" />

    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Datepicker from 'vuejs-datepicker';
import status from '../../../resources/status.json';
import country from '../../../resources/country.json';
import tran_group from '../../../resources/tran_group.json';
import trantype from '../../../resources/biz_get_trantype.json';
export default {
  components: {
    AgGridVue,
    'v-select': vSelect,
    flatPickr,
    Datepicker
  },
  data() {
    let today = new Date()
    let yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)
    today = today.getFullYear()+ "-" + (today.getMonth() + 1) + "-" + today.getDate()
    yesterday = yesterday.getFullYear()+ "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate()
    let data = {
      popupActive: false,
      clientInvoice: null,
      popupGroup:false,
      popupUpdateClient: false,
      popupBankDeposit: false,
      popupUpdateBroker: false,
      popupRefund: false,
      popupTLID: false,
      popupManual:false,
      popupInvoiceActive: false,
      params:{created_at1: today,amount1: 0},
      searchParams:{},
      lineDetails:{},
      country:country,
      currencies:[],
      brokers: this.$store.state.brokers,
      status:status,
      tran_group:tran_group,
      account: this.$store.state.accounts,
      trantype:trantype,
      filesCounter:0,
      curAccount: null,
      fromDate: '1970-10-10',
      toDate: today,
      dateRange:null,
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null,
        mode: "range",
      },
      clientList:[],
      searchQuery: '',
      maxPageNumbers: 7,
      gridApi: null,
      tableData:[],
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      }
    }
    let firstColumns = {
      headerName: 'tl_id',
      field: 'tl_id',
      filter: true,
      width: 175,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      headerCheckboxSelection: true,
      cellStyle: function(params) {
        let color = '#FFFFFF';
        if(params.data.color!=='' && params.data.color!==null)
          color = params.data.color;
        return {backgroundColor: color, color:'#FFFFFF'};
      }
    }
    data.columnDefs= JSON.parse(localStorage.getItem('depositsColumns'));
    data.columnDefs.unshift(firstColumns);
    for(let i in this.$store.state.brokers){
      data.params.bk_name1 = this.$store.state.brokers[i];
      break;
    }
    this.overlayLoadingTemplate =
      '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
    let that = this;
    data.gridOptions = {
      onRowDoubleClicked: function(event){ that.popupUpdateClient = true; that.lineDetails = event.data;  },
      onDragStopped: function(){ that.saveState(); }
    }
    return data;
  },
  watch: {
    'params.account_name1'() {
      if(this.params.account_name1!==this.curAccount){
        this.curAccount = this.params.account_name1;
        this.getCurrencies();
      }
    },
  },
  computed: {
    amount:{
      get: function(){
        if(this.params.amount1!==undefined)
          return this.formatNumber(this.params.amount1);
        return false;
      },
      set: function(num){
        this.params.amount1=num;
      }
    },
    showWindow(){
      if(this.$route.path==='/banking/list'){
        return true;
      }
      return false;
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 50
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    getClientsList: function(){
      this.popupInvoiceActive = true;
    },
    onCellClicked: function(event){
      if(event.colDef.field==='username'){
        window.open('/clients/'+event.data.user_id+'/'+event.value, '_blank');
      }      
      if(event.colDef.field!=='id'){
        this.copyToClipBoard(event.value);
      }
    },
    copyToClipBoard: function(value){
        let that = this;
        let text = value;
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            if(document.execCommand('copy'))
                that.openAlert('success','','copied to clipboard');
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
    },
    goTo: function(where){
      if(where==='details')
        window.open('/pdf/create', '_blank');
      else if(where==='invoices')
        window.open('/invoice/'+this.clientInvoice, '_blank');
    },
    formatNumber: function(num) {
      num = num.toString().split(',').join('');
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    onGridReady: function(){
      this.setData();
      this.loadState();
    },
    resetDate: function(){
      let today = new Date()
      today = today.getFullYear()+ "-" + (today.getMonth() + 1) + "-" + today.getDate()
      this.fromDate= '1970-10-10';
      this.toDate= today;
      this.dateRange=null;
    },
    onRangeChange(selectedDates, dateStr) {
      let range = dateStr.split(' to ');
      this.fromDate = range[0];
      this.toDate = range[1];
    },
    getType: function(name){
      if(this.gridColumnApi===undefined)
        return 'filled';
      let colState = this.gridColumnApi.getColumnState();
      for(let i in colState){
        if(colState[i].colId===name){
          return colState[i].hide === false ? 'filled' : 'border';
        }
      }
      return 'filled';
    },
    showHideColumn: function(name){
      let colState = this.gridColumnApi.getColumnState();
      let hideCol = false;
      for(let i in colState){
        if(colState[i].colId===name){
          hideCol = colState[i].hide;
          break;
        }
      }
      this.gridColumnApi.setColumnVisible(name, hideCol);
      this.saveState();
    },
    saveState: function(){
      try{
        localStorage.setItem('bankingColStage', JSON.stringify(this.gridColumnApi.getColumnState()));
        localStorage.setItem('bankingSortStage', JSON.stringify(this.gridApi.getSortModel()));
      } catch (e){console.log('err',e)}
    },
    loadState: function(){
      try{
        let colState = JSON.parse(localStorage.getItem('bankingColStage'));
        let sortState = JSON.parse(localStorage.getItem('bankingSortStage'));
        if(colState!==null)
          this.gridColumnApi.setColumnState(colState);
        if(sortState!==null)
          this.gridApi.setSortModel(sortState);
      } catch (e){ console.log('err',e)}
    },
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    showDod: function(){
      window.open('/dod', '_blank');
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    sendData: function(type){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      switch(type){
        case 'refund':{          
          let list= this.gridApi.getSelectedRows();
          let ids = ''
          for (let i in list) {
            ids += ','+list[i].tl_id;
          }
          ids = ids.substring(1);
          params.append('tl_id', ids);
          params.append('account', this.params.destination.acc_name);          
          params.append('comments', this.params.comments);
          break;
        }
        case 'send-group':{
          let list= this.gridApi.getSelectedRows();
          let ids = ''
          for (let i in list) {
            ids += ','+list[i].tl_id;
          }
          ids = ids.substring(1);
          params.append('tl_id', ids);
          params.append('amount', this.params.amount);
          params.append('destination', this.params.destination.acc_name);
          params.append('tran_type', this.params.tran_type.t_desc);
          break;
        }
        case 'new-id':{
          params.append('old_id', this.lineDetails.id);
          params.append('new_id', this.params.new_id);
          break;
        }
        case 'delete-deposit':
        case 'bank-oft':
        case 'unmatch-client':{
          let list= this.gridApi.getSelectedRows();
          let ids = ''
          for (let i in list) {
            ids += ','+list[i].tl_id;
          }
          ids = ids.substring(1);
          params.append('tl_id', ids);
          break;
        }
        case 'bank-deposit':
          params.append('created_at1', this.params.created_at1);
          params.append('account_name1', this.params.account_name1.acc_name);
          params.append('bk_name1', this.params.bk_name1.bk_name);
          params.append('amount1', (this.params.amount1).replace(',',''));
          params.append('curname1', this.params.curname1.currency);
          params.append('comments1', this.params.comments1);
          params.append('sender_name1', this.params.sender_name1);
          params.append('from_acc1', this.params.from_acc1);
          params.append('descript1', this.params.descript1);
          params.append('ext_ref1', this.params.ext_ref1);
          break;
        case 'update-manual':
           params.append('reference', this.params.reference);
           params.append('reference_string', this.params.reference_string);
           break;
        case 'update-broker':{
          params.append('bk_name1', this.params.bk_name1.bk_name);
          let list= this.gridApi.getSelectedRows();
          let ids = ''
          for (let i in list) {
            ids += ','+list[i].tl_id;
          }
          ids = ids.substring(1);
          params.append('tl_id', ids);
          break;
        }
      }
      this.$vs.loading();
      axios.post("/api/banking",params)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data[0].out1==='done!'){
          this.gridApi.deselectAll();
          that.setData(true);
          let today = this.params.created_at1;
          if(type!=='bank-deposit')
            that.params = {created_at1: today,amount1: 0,bk_name1:{bk_name:"crosser"}};
          that.closePopups();
          that.openAlert('success','Success',data.data[0].out1);
        } else{
          that.openAlert('danger','Failed',data.data[0].out1);
        }
        })
      .catch((error) => { console.log('e',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    getCurrencies: function(){
      let params = {};
      let that = this;
      if(this.params.account_name1===undefined)
        return false;
      params.account_name = this.params.account_name1.acc_name;
      axios.get("/api/banking?list=currencies&account="+params.account_name)
      .then((data) => {
        that.currencies.splice(0);
        for(let i in data.data){
          let obj = JSON.parse(data.data[i].object);
          if(that.params.curname1===undefined || that.params.curname1===null)
            that.params.curname1 = obj;
          that.currencies.push(obj);
        }        
      }) 
      .catch((error) => { console.log('e',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    closePopups: function(){
      this.popupBankDeposit = false;
      this.popupActive = false;
      this.popupGroup = false;
      this.popupUpdateClient = false;
      this.popupUpdateBroker = false;
    },
    compare: function(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = Number(a.id);
      const bandB = Number(b.id);

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    setData: function(isSubmit){
        this.gridApi.showLoadingOverlay();
        const params = new URLSearchParams();
        params.append('action', 'banking-list');
        let data1 = '';
        if(isSubmit){
          for(let i in this.searchParams.brokers){
            data1 += '&broker-search[]='+this.searchParams.brokers[i].bk_name;
          }
          for(let i in this.searchParams.status){
            data1 += '&status-search[]='+this.searchParams.status[i].st_name;
          }
          for(let i in this.searchParams.country){
            data1 += '&broker-search[]='+this.searchParams.country[i].cl_Country;
          }
          for(let i in this.searchParams.account){
            data1 += '&account-search[]='+this.searchParams.account[i].acc_name;
          }
          for(let i in this.searchParams.tran_group){
            data1 += '&tran_group-search[]='+this.searchParams.tran_group[i].t_name;
          }
        }
        params.append('filter', 'start='+this.fromDate+'&end='+this.toDate+data1);
        let that = this;
        axios.post("/api/table",params)
        .then((response) => {
          that.tableData.splice(0);
          for(let i in response.data.OriginalData){
            let data = response.data.OriginalData[i];
            data.action = '';
            that.tableData.push(data);
          }
          that.tableData.sort(this.compare).reverse();
        })
        .catch((error) => { console.log('error',error) })
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  }
}

</script>
